package com.starparty.app.astro0.renderers

import com.starparty.app.astro0.SP_Canvas
import com.starparty.app.astro0.SP_Colour
import com.starparty.app.astro0.SP_Paint
import com.starparty.app.astro0.Sky
import com.starparty.app.astro0.celestialobjects.CelestialBody
import com.starparty.app.astro0.celestialobjects.OrbitalBody
import com.starparty.app.geometry.SP_Rectangle
import kotlin.math.PI

object OrbitalBodyRenderer : CelestialBodyRenderer() {

    internal var DEF_SIZE = 15.0
    internal var DEF_SUN_MOON_SIZE = 30.0

    override fun getDiameter(b: CelestialBody): Double {
        var diameter = DEF_SIZE
        if (b.name === "Sun" || b.name === "Moon") {
            diameter = DEF_SUN_MOON_SIZE
        }

        return diameter
    }

    override fun paintDetailedCelestialBody(b: CelestialBody,
                                            radius: Double,
                                            left:Double,
                                            top:Double,
                                            x:Double,
                                            y:Double,
                                            bodyP: SP_Paint,
                                            theme: RendererTheme,
                                            g: SP_Canvas
    ) {
        if (b is OrbitalBody) {
            if (b.hasPhases) {
                val darkP = theme.darkPhasePaint
                g.drawCircleFilled(x, y, radius, darkP)
                drawPhase(b, b.getPhase(), radius, x, y, left,top, bodyP, darkP, g)
               // g.drawCircleUnfilled(x, y, r, bodyP)
            }
            else {
                super.paintDetailedCelestialBody(b, radius, left, top, x, y, bodyP, theme,g)
            }
        }
        else {
            super.paintDetailedCelestialBody(b, radius, left, top, x, y, bodyP, theme,g)
        }
    }

    fun drawPhase(b: CelestialBody,
                  phase: Double,
                  radius: Double,
                  x: Double,
                  y: Double,
                  left:Double,
                  top:Double,
                  bodyP: SP_Paint,
                  darkP: SP_Paint,
                  g: SP_Canvas) {
        val d = radius * 2.0

        if (phase >= 0.0 && phase < 1.0) {
            g.drawArcFilled(x, y, 1.5 * PI, 0.5 * PI, radius, bodyP)
            val ovalPaint = darkP
            var ovalWidth = 1.0 - phase
            g.drawOvalFilled(SP_Rectangle(left + radius - (ovalWidth * radius), top, (ovalWidth * d), d), ovalPaint)
        } else if (phase >= 1.0 && phase < 2.0) {
            g.drawArcFilled(x, y, 1.5 * PI, 0.5 * PI, radius, bodyP)
            val ovalPaint = bodyP
            var ovalWidth = phase - 1.0
            g.drawOvalFilled(SP_Rectangle(left + radius - (ovalWidth * radius), top, (ovalWidth * d), d), ovalPaint)
        } else if (phase >= 2.0 && phase < 3.0) {
            g.drawArcFilled(x, y, 0.5 * PI, 1.5 * PI, radius, bodyP)
            val ovalPaint = bodyP
            var ovalWidth = 1.0 - (phase - 2.0)
            g.drawOvalFilled(SP_Rectangle(left + radius - (ovalWidth * radius), top, (ovalWidth * d), d), ovalPaint)
        } else if (phase >= 3.0 && phase <= 4.0) {
            g.drawArcFilled(x, y, 0.5 * PI, 1.5 * PI, radius, bodyP)
            val ovalPaint = darkP
            var ovalWidth = phase - 3.0
            g.drawOvalFilled(SP_Rectangle(left + radius - (ovalWidth * radius), top, (ovalWidth * d), d), ovalPaint)
        } else {
            // invalid phase
        }

    }

    override fun getColour(c: CelestialBody):SP_Colour { return c.rgbColour }

    override fun getLabelFontSize(labelType: Int, rendererTheme: RendererTheme): Float {

        var fontSize: Float = rendererTheme.celestialBodyFullLabelFontSize
        if (labelType == Sky.ABBR_TITLES) {
            fontSize = rendererTheme.orbitalBodyAbbrevLabelFontSize
        }

        return fontSize
    }
}